import WaLabelService from '../../services/WaLabelService'

// Etiquetas de conversa do WhatsApp: lista do tenant + mapa telefone → ids de etiqueta
const state = () => ({
    waLabels: [],
    /** { [phone]: [labelId, ...] } */
    waLabelAssignments: {},
    loadingWaLabels: false,
    savingWaLabel: false,
})

const mutations = {
    SET_WA_LABELS: (state, payload) => {
        state.waLabels = payload || []
    },
    SET_WA_LABEL_ASSIGNMENTS: (state, rows) => {
        const map = {}
        for (const row of rows || []) {
            if (!map[row.phone]) map[row.phone] = []
            map[row.phone].push(row.WaLabelId)
        }
        state.waLabelAssignments = map
    },
    /** Toggle otimista de uma atribuição (revertido pela action em caso de erro) */
    TOGGLE_WA_LABEL_ASSIGNMENT: (state, { phone, labelId }) => {
        const current = state.waLabelAssignments[phone] || []
        const next = current.includes(labelId)
            ? current.filter(id => id !== labelId)
            : [...current, labelId]
        state.waLabelAssignments = { ...state.waLabelAssignments, [phone]: next }
    },
    SET_LOADING_WA_LABELS: (state, payload) => {
        state.loadingWaLabels = payload
    },
    SET_SAVING_WA_LABEL: (state, payload) => {
        state.savingWaLabel = payload
    },
}

const actions = {
    async fetchWaLabels({ commit }) {
        try {
            commit('SET_LOADING_WA_LABELS', true)
            const response = await WaLabelService.list()
            commit('SET_WA_LABELS', response.data)
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao carregar as etiquetas.'
            })
        } finally {
            commit('SET_LOADING_WA_LABELS', false)
        }
    },

    async fetchWaLabelAssignments({ commit }) {
        try {
            const response = await WaLabelService.assignments()
            commit('SET_WA_LABEL_ASSIGNMENTS', response.data)
        } catch (error) {
            console.error('Falha ao carregar etiquetas das conversas:', error)
        }
    },

    async createWaLabel({ commit, dispatch }, { name, color }) {
        try {
            commit('SET_SAVING_WA_LABEL', true)
            await WaLabelService.create({ name, color })
            await dispatch('fetchWaLabels')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao criar a etiqueta.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_LABEL', false)
        }
    },

    async updateWaLabel({ commit, dispatch }, { id, name, color }) {
        try {
            commit('SET_SAVING_WA_LABEL', true)
            await WaLabelService.update(id, { name, color })
            await dispatch('fetchWaLabels')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao atualizar a etiqueta.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_LABEL', false)
        }
    },

    async deleteWaLabel({ commit, dispatch }, id) {
        try {
            commit('SET_SAVING_WA_LABEL', true)
            await WaLabelService.remove(id)
            await dispatch('fetchWaLabels')
            await dispatch('fetchWaLabelAssignments')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao excluir a etiqueta.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_LABEL', false)
        }
    },

    /** Atribui/remove etiqueta da conversa — otimista, reverte se a API falhar */
    async toggleWaLabelAssignment({ commit }, { phone, labelId }) {
        commit('TOGGLE_WA_LABEL_ASSIGNMENT', { phone, labelId })
        try {
            await WaLabelService.toggle(phone, labelId)
        } catch (error) {
            commit('TOGGLE_WA_LABEL_ASSIGNMENT', { phone, labelId })
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao atualizar a etiqueta da conversa.'
            })
        }
    },
}

const getters = {
    getWaLabels: state => state.waLabels,
    getWaLabelAssignments: state => state.waLabelAssignments,
    getLoadingWaLabels: state => state.loadingWaLabels,
    getSavingWaLabel: state => state.savingWaLabel,
}

export default {
    state,
    getters,
    mutations,
    actions
};
